<template>
  <div>
    <main-layout>
      <div>
        <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
          <v-tab href="#dashboard" ripple>{{ $t('Dashboard') }}</v-tab>
          <v-tab href="#agent" ripple>{{ $t('Agent View') }}</v-tab>
          <v-tab href="#funnel" ripple>{{ $t('Funnel View') }}</v-tab>
          <v-tab
            href="#users"
            ripple
            v-if="$store.state.privilege && $store.state.privilege.agent_management"
            >{{ $t('Admin/Agent User Management') }}</v-tab
          >
        </v-tabs>
        <div :key="currentView">
          <component :is="currentView"></component>
        </div>
        <div style="height: 60px"></div>
      </div>
    </main-layout>
  </div>
</template>

<script>
import Dashboard from './Dashboard'
import Agent from './Agent'
import Funnel from './Funnel'
import Users from './Users'
export default {
  data() {
    return {
      currentView: 'dashboard'
    }
  },
  components: {
    Dashboard,
    Agent,
    Funnel,
    Users
  },
  created() {
    let vm = this
    if (vm.$route.query.tab) {
      switch (vm.$route.query.tab) {
        case 'dashboard':
        case 'agent':
        case 'funnel':
        case 'users':
          vm.currentView = vm.$route.query.tab
          break
        default:
          vm.currentView = 'dashboard'
          break
      }
    } else {
      vm.currentView = 'dashboard'
    }
  },
  mounted() {
    this.$store.dispatch('loadAgents')
    this.$store.dispatch('loadAgentGroups')
    this.$store.dispatch('loadAgentSubGroups')
  },
  methods: {
    updateRoute: function() {
      this.$router.push({
        name: 'ticket',
        path: '/ticket',
        query: {
          tab: this.currentView
        }
      })
      this.routeValue = JSON.stringify(this.$route.query)
    }
  },
  watch: {
    currentView: function() {
      this.updateRoute()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/main.vue